export const buildArticleJsonLd = ({
  headline,
  description,
  url,
  imageUrl,
  datePublished,
  authorName,
}: {
  headline: string
  description?: string
  url: string
  imageUrl?: string
  datePublished: string
  authorName?: string
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline,
  description,
  url,
  image: imageUrl ? [imageUrl] : undefined,
  datePublished,
  author: authorName
    ? {
        '@type': 'Person',
        name: authorName,
      }
    : undefined,
})
